import Vue from 'vue';
import { getSwiper, getSwiperModules } from '../utils';

Vue.component('aftersales-services-carousel', {
    data() {
        return {
            tabIndex: 0,
            sectionIndex: 0,
            swiperInstance: null,
            resizeObserver: null,
            lastIsMobile: null,
        };
    },

    async mounted() {
        await this.initSwiper();
        this.watchBreakpoint();
    },

    beforeDestroy() {
        if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true);
            this.swiperInstance = null;
        }
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    },

    methods: {
        switchSection(index) {
            if (index != this.tabIndex) {
                this.tabIndex = index;
                this.sectionIndex = index;

                setTimeout(() => this.initSwiper(), 100);
            }
        },

        watchBreakpoint() {
            this.lastIsMobile = window.innerWidth < 768;

            this.resizeObserver = new ResizeObserver(() => {
                const isMobile = window.innerWidth < 768;
                if (isMobile !== this.lastIsMobile) {
                    this.lastIsMobile = isMobile;
                    this.initSwiper();
                }
            });

            this.resizeObserver.observe(document.body);
        },

        async initSwiper() {
            if (this.swiperInstance) {
                this.swiperInstance.destroy(true, true);
                this.swiperInstance = null;
            }

            const { Swiper } = await getSwiper();
            const { Scrollbar, Navigation } = await getSwiperModules();
            const isMobile = window.innerWidth < 768;
            const isLargeDesktop = window.innerWidth >= 1600;

            const isAccessoriesCarousel = !!this.$el.closest(
                '.aftersales-accessories__carousel-container',
            );
            const isServicesHomepage =
                !isAccessoriesCarousel &&
                !!this.$el.closest('.aftersales__wrapper');
            const isHomepageDesktop = isServicesHomepage && !isMobile;

            const el = this.$el.querySelector(
                '.aftersales-services-carousel__slider',
            );
            const scrollbarEl = this.$el.querySelector('.swiper-scrollbar');
            const navigationContainer = this.$el.querySelector(
                isMobile
                    ? '.aftersales__carousel-buttons--mobile'
                    : '.aftersales__carousel-buttons--desktop',
            );
            const nextEl = navigationContainer?.querySelector(
                '.aftersales__carousel-button--next',
            );
            const prevEl = navigationContainer?.querySelector(
                '.aftersales__carousel-button--prev',
            );

            if (!el) return;

            const offset = isMobile ? 20 : 40;
            const slidesOffsetBefore = isAccessoriesCarousel
                ? 0
                : isServicesHomepage
                ? 0
                : offset;
            const slidesOffsetAfter = isServicesHomepage ? 0 : offset;
            const slidesPerView = isMobile
                ? 'auto'
                : isHomepageDesktop
                ? 'auto'
                : isLargeDesktop
                ? 3
                : 3.1;
            const spaceBetween = isMobile && isServicesHomepage ? 20 : 32;

            this.swiperInstance = new Swiper(el, {
                slidesPerView,
                spaceBetween,
                slidesOffsetBefore,
                slidesOffsetAfter,
                loop: false,
                watchOverflow: true,
                observer: true,
                observeParents: true,
                centeredSlides: false,
                modules: [Scrollbar, Navigation],
                pagination: {},
                scrollbar: {
                    el: scrollbarEl,
                    hide: false,
                    draggable: true,
                },
                uniqueNavElements: true,
                navigation: {
                    nextEl,
                    prevEl,
                },
            });
        },
    },
});
